import { useEffect, useState } from "react";
import axios from "axios";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Story } from "@/components/Story";
import { PictureThis } from "@/components/PictureThis";
import { MeetShellie } from "@/components/MeetShellie";
import { Outcomes } from "@/components/Outcomes";
import { Included } from "@/components/Included";
import { ForYouAndFaq } from "@/components/ForYouAndFaq";
import { FinalCta, Footer, StickyCta } from "@/components/FinalCta";
import { Application } from "@/components/Application";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FALLBACK_BOOKING_URL = "https://calendly.com/your-link-here";

export default function LandingPage() {
  const [bookingUrl, setBookingUrl] = useState(FALLBACK_BOOKING_URL);

  useEffect(() => {
    axios
      .get(`${API}/config`)
      .then((res) => res.data?.booking_url && setBookingUrl(res.data.booking_url))
      .catch(() => {});
  }, []);

  const scrollToApply = () => {
    document.getElementById("apply")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <main data-testid="landing-page" className="pb-20 sm:pb-0">
      <Header onApply={scrollToApply} />
      <Hero onApply={scrollToApply} />
      <Marquee />
      <Story />
      <PictureThis />
      <MeetShellie />
      <Outcomes />
      <Included />
      <Marquee />
      <ForYouAndFaq />
      <Application bookingUrl={bookingUrl} />
      <FinalCta onApply={scrollToApply} />
      <Footer />
      <StickyCta onApply={scrollToApply} />
    </main>
  );
}
